<template>
	<div id="buildingRightTop">
		<dv-border-box-8>
			<div class="d-flex pt-2 pl-2 pb-2">
				<div class="d-flex">
					<p class="mt-3 ml-3 title_t">图形监控</p>
				</div>
			</div>
			<div id="plan-wrap" class="plan-wrap ml-1" :class="isFull === false ? 'no-full' : 'full'">
				<div id="plan_box" class="plan_box">
					<div id="plan" class="plan" ref="plan"></div>
					<i class="el-icon-full-screen fullBtn" @click="fullScreen()"></i>
				</div>
				<div style="height:0.4rem;">
					<div class="float-l" style="width:17%;">
						<div class="float-l ml-4" @click="changeType(true)" :class="isFloor ? 'typeButton' : 'primary'">
							<p>楼层</p>
						</div>
						<div class="float-l ml-3" @click="changeType(false)"
							:class="isFloor ? 'primary' : 'typeButton'">
							<p>系统</p>
						</div>
					</div>
					<div class="list float-l" style="width:83%;">
						<ul v-if="isFloor">
							<li class="float-l" v-for="(i,index) in listArr" :class="i.code == showCode?'sebutton':''"
								@click="isFloor?getFloorsPlan(i.code):getSystemsPlan(i.code)" :key="index">{{ i.name }}
							</li>
						</ul>
						<ul v-else>
							<li class="float-l system" v-for="(i,index) in listArr" :class="i.code == showCode?'sebutton':''"
								@click="isFloor?getFloorsPlan(i.code):getSystemsPlan(i.code)" :key="index">{{ i.name }}
							</li>
						</ul>
					</div>
				</div>
				<div id="menu" class="none pf">
					<ul>
						<li @click="deviceDialogVisible = true">设备概况</li>
						<li @click="dialogVisible = true">设备控制</li>
					</ul>
				</div>

				<Control v-if="dialogVisible" :deviceCode="deviceCode" :kind="kind"
					@changeDialogVisible="changeDialogVisible" />
				<el-dialog width="1000px" :append-to-body='true' :visible="deviceDialogVisible"
					@close="deviceDialogVisible = false">
					<h1 slot="title" style="font-size: 0.25rem">设备概况</h1>
					<DeviceSurvey :code="deviceCode" :kind="kind" v-if="deviceDialogVisible" />
				</el-dialog>
			</div>
		</dv-border-box-8>
	</div>
</template>

<script>
	import $ from 'jquery';
	import {
		addEvent,
		removeEvent
	} from '@/utils/index';
	import Control from "@/components/Control/Control";
	import DeviceSurvey from "@/components/DeviceSurvey/DeviceSurvey";
	export default {
		data() {
			return {
				dataModel: {},
				graphView: {},
				interval: null,
				isFloor: true,
				listArr: [],
				poolInterval: null,
				intervalList: [],
				// btnText: '全屏',
				isFull: false,
				deviceCode: '',
				systemCode: '',
				floorCode: '',
				kind: '',
				hidden: '',
				visibilitychange: '',
				dialogVisible: false,
				deviceDialogVisible: false,
				returnList: [],
				showCode: ''
			};
		},
		components: {
			Control,
			DeviceSurvey
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.init();
				},
			}
		},
		created() {
			this.init();
		},
		mounted() {
			// 设置隐藏属性和改变可见属性的事件的名称
			this.visibilityChange();
		},
		activated() {
			this.onContextMenu(); // 自定义右键菜单
		},
		destroyed() {
			clearInterval(this.interval);
			this.intervalClear();
			removeEvent(document, this.visibilityChange, this.handlerVisibilityChange);
		},
		methods: {
			init() {
				// 清除所有定时器
				clearInterval(this.interval);
				this.intervalClear();
				let dataObj = {
					building_id: this.building
				}
				if (this.isFloor) {
					this.$axios.get("/api/floors", {
						params: dataObj
					}).then(res => {
						this.floorCode = res.data.data[0].code
						this.listArr = res.data.data
						this.getFloorsPlan(this.floorCode);
						// 间隔5min更新一次数据，将所有的定时器存放在数组中
						this.interval = setInterval(this.floorInit, 300000);
					})
				} else {
					this.$axios.get("/api/airConditionSystems", {
						params: dataObj
					}).then(res => {
						this.systemCode = res.data.data[0].code
						this.listArr = res.data.data
						this.getSystemsPlan(this.systemCode);
						// 间隔5min更新一次数据，将所有的定时器存放在数组中
						this.interval = setInterval(this.systemInit, 300000);
					})
				}
			},
			async changeType(type) {
				this.isFloor = type
				this.init()
			},
			async getFloorsPlan(code) {
				this.showCode = code
				this.floorCode = code
				let dataObj = {
					floorCode: code
				}
				$('.plan').empty();
				await this.$axios.get("/api/floors/getPlan", {
					params: dataObj
				}).then(res => {
					this.addGraphView(res.data.data);
				})
			},
			async getSystemsPlan(code) {
				this.showCode = code
				this.systemCode = code
				let dataObj = {
					systemCode: code
				}
				$('.plan').empty();
				await this.$axios.get("/api/airConditionSystems/getPlan", {
					params: dataObj
				}).then(res => {
					this.addGraphView(res.data.data);
				})
			},
			addGraphView(data) {
				$('.plan').empty();
				let dataModel = new ht.DataModel(); // 数据容器
				this.dataModel = dataModel;
				let graphView = new ht.graph.GraphView(dataModel); // 2d 绑定数据模型
				this.graphView = graphView;
				let view = graphView.getView();
				view.className = 'ht_box';
				// 获取和设置滚动条宽度
				graphView.setScrollBarSize(0);
				// 缩放平移整个拓扑以展示所有的图元
				graphView.fitContent();
				graphView.deserialize(data);
				graphView.setInteractors([
					new ht.graph.DefaultInteractor(graphView),
					new ht.graph.TouchInteractor(graphView, {
						editable: false, // 编辑
						selectable: false, // 选中
						movable: false, // 移动
						pinchable: true, // 缩放
						pannable: false, // 平移
					}),
					// new CreateShapeInteractor(graphView),
				]); // null 或 false 为去掉所有默认交互功能
				// this.$el指向根元素，this.$refs.plan指向ref='paln'的元素，不指定加入到document.body下
				graphView.addToDOM(this.$refs.plan);

				if (this.isFloor) {
					this.floorInit();
				} else {
					this.systemInit();
				}
				this.onContextMenu(); // 自定义右键菜单
			},
			floorInit() {
				// 清除所有定时器
				this.intervalClear();
				if (this.dataModel.getDataByTag('sbsl')) {
					this.getFloorParam();
				}
				this.getTemperatureHumidity();
			},
			async getFloorParam() {
				let dataObj = {
					floorCode: this.floorCode
				}
				await this.$axios.get("/api/floors/getPlanParam", {
					params: dataObj
				}).then(res => {
					this.dataModel.getDataByTag('sbsl').s('text', res.data.data.floor_device_count);
					this.dataModel.getDataByTag('yjsl').s('text', res.data.data.floor_compressor_count);
					this.dataModel.getDataByTag('yxsl').s('text', res.data.data.floor_device_open);
					this.dataModel.getDataByTag('yjyx').s('text', res.data.data.floor_compressor_open);
					this.dataModel.getDataByTag('zlgl').s('text', res.data.data.floor_refrigerating_power);
					this.dataModel.getDataByTag('zll').s('text', res.data.data.floor_refrigerating_capacity);
					this.dataModel.getDataByTag('dqgj').s('text', res.data.data.fault_survey_floor);
				})
			},
			async getTemperatureHumidity() {
				let dataObj = {
					floorCode: this.floorCode
				}
				let data = await this.$axios.get("/api/floors/devices/temperatureHumidity", {
					params: dataObj
				})
				let snwdList = [];
				let snsdList = [];
				for (let item of data.data.data) {
					try {
						let kt = this.dataModel.getDataByTag(item.code + '_kt');
						if (kt) {
							let wsd = item.SNWD + '℃\n' + item.SNSD + '%';
							this.dataModel.getDataByTag(item.code + '_wsd').a('ht.content', wsd);
							let yj1 = item.YJ1ZT ? true : false;
							let yj2 = item.YJ2ZT ? true : false;
							kt.a('yj1.show', yj1);
							kt.a('yj2.show', yj2);
							if (item.KGJZT) {
								kt.a('kt.state', 'open');
							} else {
								kt.a('kt.state', 'close');
							}
							// 告警信号
							if (item.BJXH !== 0) {
								kt.a('kt.state', 'warning');
							}

							// 判断是否离线
							if (item.is_offline) {
								kt.a('kt.bg', '#949494');
								kt.a('fs.bg', '#949494');
							} else {
								kt.a('kt.bg', '#409eff');
								kt.a('fs.bg', '#409eff');
								item.SNWD !== '-' && item.SNWD !== 'null' && snwdList.push(item.SNWD);
								item.SNSD !== '-' && item.SNSD !== 'null' && snsdList.push(item.SNSD);

								// 空调状态
								if (item.KGJZT) {
									// 让风扇转动
									kt._interval = setInterval(() => {
										kt.a('fanAngle', kt.a('fanAngle') + 0.06);
									}, 20);
									this.intervalList.push(kt._interval);
								} else {
									clearInterval(kt._interval);
								}
							}
						}
					} catch (e) {
						// this.$tip(`空调${item.location}-${item.code}有问题！`, 'warning');
						// console.error(`空调${item.location}-${item.code}有问题！`);
						// console.error(e);
					}
				}
				// console.log(this.intervalList);
				// 图纸上面的温湿度范围
				if (this.dataModel.getDataByTag('wd')) {
					if (!snwdList.length) {
						snwdList = [0];
					}
					if (!snsdList.length) {
						snsdList = [0];
					}
					// console.log(snwdList,snwdList)
					let wd_min = Math.min.apply(null, snwdList);
					let wd_max = Math.max.apply(null, snwdList);
					let sd_min = Math.min.apply(null, snsdList);
					let sd_max = Math.max.apply(null, snsdList);
					this.dataModel.getDataByTag('wd').s('text', `${wd_min}~${wd_max}℃`);
					this.dataModel.getDataByTag('sd').s('text', `${sd_min}~${sd_max}%`);
				}
			},
			async systemInit() {
				// 清除所有定时器
				this.intervalClear();
				this.pumpHandle();
				this.airHandle();

				// 启动ToolTip
				this.graphView.enableToolTip();
				// 给tooltip添加内容
				this.graphView.getToolTip = e => {
					let data = this.graphView.getDataAt(e);
					if (data) {
						if (data._displayName === 'kz2') {
							let snwd = data.a('kt.snwd');
							let snsd = data.a('kt.snsd');
							let html = `<div class="htTip"><p>温度：${snwd}</p><p>湿度：${snsd}</p></div>`;
							return {
								html: html
							};
						}
					}
				};
			},
			async pumpHandle() {
				let dataObj = {
					systemCode: this.systemCode
				}
				let data = await this.$axios.get("/api/pumps/currentRunning", {
					params: dataObj
				})
				// 判断是否是新版系统图
				if (this.dataModel.getDataByTag('wdfw')) {
					this.graphView.enableDashFlow(200); //启动虚线流动，默认为false，interval表示流动的时间间隔
					if (this.dataModel.getDataByTag('lqtzt')) {
						this.dataModel.getDataByTag('lqtzt').s('text', '关');
					}
					let pumpOpenList = [];
					// console.log(data)
					for (let item of data.data.data) {
						if (this.dataModel.getDataByTag(item.SBID + '_open') && this.dataModel.getDataByTag(item.SBID +
								'_close')) {
							let open = this.dataModel.getDataByTag(item.SBID + '_open');
							let close = this.dataModel.getDataByTag(item.SBID + '_close');
							if (item.KGJ) {
								close.a('btn.bg', '#DBDBDB');
								close.a('btn.color', '#6E6E6E');
								open.a('btn.bg', '#3597FF');
								open.a('btn.color', '#FFFFFF');
								if (this.dataModel.getDataByTag('lqtzt')) {
									this.dataModel.getDataByTag('lqtzt').s('text', '开');
								}
							} else {
								open.a('btn.bg', '#DBDBDB');
								open.a('btn.color', '#6E6E6E');
								close.a('btn.bg', '#3597FF');
								close.a('btn.color', '#FFFFFF');
							}
						} else {
							if (item.KGJ) {
								if (this.dataModel.getDataByTag('lqtzt')) {
									this.dataModel.getDataByTag('lqtzt').s('text', '开');
								}
							}
						}
						pumpOpenList.push(item.KGJ);
						if (this.dataModel.getDataByTag(item.SBID + '_zt') && this.dataModel.getDataByTag(item.SBID +
								'_dl')) {
							let state = item.KGJ ? '开' : '关';
							let offline = item.is_offline ? '离线' : '在线';
							this.dataModel.getDataByTag(item.SBID + '_zt').s('text', `${state}-${offline}`);
							// this.dataModel.getDataByTag(item.SBID + '_zt').s('text', `${state}`);
							this.dataModel.getDataByTag(item.SBID + '_dl').s('text', `${item.YXPL}A`);
						}
						try {
							let boolean = item.KGJ === 0 ? false : true;
							this.dataModel.getDataByTag(item.SBID + '_switch1').a('closed', !boolean);
							this.dataModel.getDataByTag(item.SBID + '_switch2').a('closed', !boolean);
							this.dataModel.getDataByTag(item.SBID + '_screen').a('deep', Number(item.YXPL));
							this.dataModel.getDataByTag(item.SBID + '_into').s('shape.dash', boolean);
							if (item.YXPL !== 0) {
								this.dataModel.getDataByTag(item.SBID + '_screen').a('color', 'rgb(73,157,71)');
							}
						} catch (e) {
							// this.$tip(`水泵${item.location}-${item.SBID}有问题！`);
							// console.error(`水泵${item.location}-${item.SBID}有问题！`);
							// console.error(e);
						}
					}
					let pools = this.dataModel.toDatas(d => {
						return d.getDisplayName() === 'pool';
					});
					if (pumpOpenList.length !== 0) {
						// toDatas(matchFunc, scope)返回筛选后的新ht.List对象数组，第一参数为空相当于复制全部对象数组
						let waters = this.dataModel.toDatas(d => {
							return d.getDisplayName() === 'lqt';
						});
						if (pumpOpenList.includes(1)) {
							this.watersShow(true);
							//冷却塔水滴滴落
							this.updateWaterDown(waters, true);
							// 冷却塔水流流动
							this.updatePoolDeep(pools, true);
							this.graphView.enableDashFlow(200); //启动虚线流动，默认为false，interval表示流动的时间间隔
						} else {
							this.watersShow(false);
							this.updateWaterDown(waters, false);
						}
					} else {
						this.watersShow(false);
						this.updatePoolDeep(pools, false);
						this.graphView.enableDashFlow(200); //启动虚线流动，默认为false，interval表示流动的时间间隔
					}
					// if (pumpOpenList.length === 0 || pumpOpenList.includes(1)) {
					//   this.graphView.enableDashFlow(200); //启动虚线流动，默认为false，interval表示流动的时间间隔
					// }
				} else {
					let pumpOpenList = [];
					for (let item of data.data.data) {
						try {
							pumpOpenList.push(item.KGJ);
							let boolean = item.KGJ === 0 ? false : true;
							this.dataModel.getDataByTag(item.SBID + '_switch1').a('closed', !boolean);
							this.dataModel.getDataByTag(item.SBID + '_switch2').a('closed', !boolean);
							this.dataModel.getDataByTag(item.SBID + '_screen').a('deep', Number(item.YXPL));
							this.dataModel.getDataByTag(item.SBID + '_into').s('shape.dash', boolean);
							if (item.YXPL !== 0) {
								this.dataModel.getDataByTag(item.SBID + '_screen').a('color', 'rgb(73,157,71)');
							}
						} catch (e) {
							// this.$tip(`水泵${item.location}-${item.SBID}有问题！`);
							// console.error(`水泵${item.location}-${item.SBID}有问题！`);
							// console.error(e);
						}
					}
					let pools = this.dataModel.toDatas(d => {
						return d.getDisplayName() === 'pool';
					});
					if (pumpOpenList.length !== 0) {
						// toDatas(matchFunc, scope)返回筛选后的新ht.List对象数组，第一参数为空相当于复制全部对象数组
						let waters = this.dataModel.toDatas(d => {
							return d.getDisplayName() === 'lqt';
						});
						if (pumpOpenList.includes(1)) {
							this.watersShow(true);
							//冷却塔水滴滴落
							this.updateWaterDown(waters, true);
							// 冷却塔水流流动
							this.updatePoolDeep(pools, true);
							this.graphView.enableDashFlow(200); //启动虚线流动，默认为false，interval表示流动的时间间隔
						} else {
							this.watersShow(false);
							this.updateWaterDown(waters, false);
						}
					} else {
						this.watersShow(false);
						this.updatePoolDeep(pools, false);
						this.graphView.enableDashFlow(200); //启动虚线流动，默认为false，interval表示流动的时间间隔
					}
				}
			},
			async airHandle() {
				let dataObj = {
					systemCode: this.systemCode
				}
				let data = await this.$axios.get("/api/gatherSystems/getcurdata", {
					params: dataObj
				})

				let snwdList = [];
				let snsdList = [];
				for (let item of data.data.data.cur_data) {
					try {
						let kt = this.dataModel.getDataByTag(item.device_code + '_kz2');
						if (!kt) {
							kt = this.dataModel.getDataByTag(item.device_code + '_ktxt2');
						}
						item.hswd = item.hswd === undefined ? '-' : item.hswd;
						item.cswd = item.cswd === undefined ? '-' : item.cswd;
						// 判断是否有水泵需求
						let isPump;
						if (item.sbzt !== undefined) {
							isPump = item.sbzt ? true : false;
						} else {
							isPump = false;
						}
						if (isPump) {
							kt.a('js.color', 'rgb(51,153,255)');
							kt.a('cs.color', 'rgb(255,153,0)');
						} else {
							kt.a('js.color', 'rgb(235,230,230)');
							kt.a('cs.color', 'rgb(235,230,230)');
						}
						kt.a('kt.snwd', item.snwd);
						kt.a('kt.snsd', item.snsd);
						kt.a('kt.yxdl', item.yjdl);
						if (this.dataModel.getDataByTag('wdfw')) {
							kt.a('kt.jswd', item.hswd);
							kt.a('kt.cswd', item.cswd);
						} else {
							let jcs = item.hswd + '℃\n' + item.cswd + '℃';
							kt.a('ht.content', jcs);
						}

						let yj1 = item.yj1zt ? true : false;
						let yj2 = item.yj2zt ? true : false;
						kt.a('yj1.show', yj1);
						kt.a('yj2.show', yj2);
						if (item.kgjzt === 1) {
							kt.a('kt.state', 'open');
						} else {
							kt.a('kt.state', 'close');
						}
						if (item.bjxh !== 0 && item.bjxh !== '未知') {
							kt.a('kt.state', 'warning');
						}

						// 判断是否离线
						if (item.is_offline) {
							kt.a('kt.bg', '#949494');
							kt.a('fs.bg', '#949494');
						} else {
							kt.a('kt.bg', '#409eff');
							kt.a('fs.bg', '#409eff');
							item.snwd !== '-' && item.snwd !== 'null' && snwdList.push(item.snwd);
							item.snsd !== '-' && item.snsd !== 'null' && snsdList.push(item.snsd);
							if (item.kgjzt === 1) {
								if (this.dataModel.getDataByTag('wdfw')) {
									// 让风扇转动
									kt._interval = setInterval(() => {
										kt.a('fanAngle', kt.a('fanAngle') + 0.06);
									}, 20);
									this.intervalList.push(kt._interval);
								}
							} else {
								clearInterval(kt._interval);
							}
						}
					} catch (e) {
						// this.$tip(`空调${item.location}-${item.device_code}有问题！`, 'warning');
						// console.error(`空调${item.location}-${item.device_code}有问题！`);
						// console.error(e);
					}
				}

				if (this.dataModel.getDataByTag('wdfw')) {
					// console.log(snwdList,snwdList)
					if (!snwdList.length) {
						snwdList = [0];
					}
					if (!snsdList.length) {
						snsdList = [0];
					}
					let survey = data.data.data.survey_data;
					let wd_min = Math.min.apply(null, snwdList);
					let wd_max = Math.max.apply(null, snwdList);
					let sd_min = Math.min.apply(null, snsdList);
					let sd_max = Math.max.apply(null, snsdList);
					this.dataModel.getDataByTag('wdfw').s('text', `${wd_min}~${wd_max}℃`);
					this.dataModel.getDataByTag('sdfw').s('text', `${sd_min}~${sd_max}%`);
					this.dataModel.getDataByTag('pzsl').s('text', survey.pzsl);
					this.dataModel.getDataByTag('yjsl').s('text', survey.yjsl);
					this.dataModel.getDataByTag('pzll').s('text', survey.pzll);
					this.dataModel.getDataByTag('pzgl').s('text', survey.pzgl);
					this.dataModel.getDataByTag('yxsl').s('text', survey.yxsl);
					this.dataModel.getDataByTag('yxyj').s('text', survey.yxyj);
					this.dataModel.getDataByTag('yxll').s('text', survey.yxll);
					this.dataModel.getDataByTag('yxgl').s('text', survey.yxgl);
					this.dataModel.getDataByTag('dqgj').s('text', survey.bjsl);
				}
			},
			updateWaterDown(waters, isDown) {
				waters.each(w => {
					if (isDown) {
						let interval = setInterval(() => {
							w.a('drip', w.a('drip') + 0.2);
						}, 30);
						w._interval = interval;
						this.intervalList.push(interval);
					} else {
						clearInterval(w._interval);
					}
				});
			},
			watersShow(b) {
				for (let i = 1; i < 4; i++) {
					if (this.dataModel.getDataByTag('lqt' + i)) {
						this.dataModel.getDataByTag('lqt' + i).a('waters.show', b);
					} else {
						break;
					}
				}
			},
			updatePoolDeep(pools, b) {
				if (b) {
					let deepDlt = 0.1,
						offsetDlt = 2;
					this.poolInterval = setInterval(() => {
						pools.each(p => {
							//console.log(p.getAnchorY());
							let flag = p.a('flag') || -1;
							let deep = p.getAnchorY() * 100;
							let v = deep + flag * deepDlt;
							if (v > 100) {
								v = 100;
								flag = -1;
							} else if (v < 60) {
								v = 60;
								flag = 1;
							}
							this.setPoolDeep(p, v);
							p.a('flag', flag);

							let offsetFlag = p.a('offsetFlag') || 1;
							let offset = (p.a('offsetX') || 0) + offsetDlt * offsetFlag;
							if (offset > 50) {
								offset = 50;
								offsetFlag = -1;
							} else if (offset < -50) {
								offset = -50;
								offsetFlag = 1;
							}
							p.a('offsetX', offset);
							p.a('offsetFlag', offsetFlag);
						});
					}, 30);
					this.intervalList.push(this.poolInterval);
				} else {
					clearInterval(this.poolInterval);
				}
			},
			setPoolDeep(pool, deep) {
				pool.getChildren().each(c => {
					if (c.getDisplayName() !== 'screen') return;
					c.a('deep', deep);
				});
				deep = deep * 0.01;
				pool.setAnchorY(deep);
				pool.s('clip.percentage', deep);
			},
			fullScreen() {
				if (this.isFull) {
					// this.btnText = '全屏';
					this.isFull = false;
					// 取消全屏
					// var el = document;
					var el = document;
					var cfs =
						el.cancelFullScreen ||
						el.webkitCancelFullScreen ||
						el.mozCancelFullScreen ||
						el.exitFullScreen;
					//typeof cfs != "undefined" && cfs
					if (cfs) {
						cfs.call(el);
					} else if (typeof window.ActiveXObject !== 'undefined') {
						//for IE，这里和fullScreen相同，模拟按下F11键退出全屏
						var wscript = new ActiveXObject('WScript.Shell');
						if (wscript != null) {
							wscript.SendKeys('{F11}');
						}
					}
				} else {
					// this.btnText = '退出';
					this.isFull = true;
					// 全屏
					var el = document.getElementById('plan-wrap');
					// var el = document.documentElement;
					var rfs =
						el.requestFullScreen ||
						el.webkitRequestFullScreen ||
						el.mozRequestFullScreen ||
						el.msRequestFullScreen;
					//typeof rfs != "undefined" && rfs
					if (rfs) {
						rfs.call(el);
					} else if (typeof window.ActiveXObject !== 'undefined') {
						//for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
						var wscript = new ActiveXObject('WScript.Shell');
						if (wscript != null) {
							wscript.SendKeys('{F11}');
						}
					}
				}
				this.init();
			},
			onContextMenu() {
				let timeOutEvent = 0 //定时器

				// 去掉右键默认菜单
				document.oncontextmenu = e => {
					// 左键--button属性=1，右键button属性=2
					if ((e.target.className == '' || e.target.className === 'ht_box' || e.target.id === 'menu') && e
						.button === 2) {
						e.preventDefault();
					}
				};

				document.onclick = e => {
					//用户触发click事件就可以关闭了，因为绑定在window上，按事件冒泡处理，不会影响菜单的功能
					$('#menu').hide();
				};

				// 去掉所有默认交互功能
				// this.graphView.setInteractors(null);
				//    let eventType = ht.Default.isTouchable ? 'touchend' : 'mouseup';

				// 图元右键
				addEvent(this.graphView.getView(), 'mouseup', e => {
					let node = this.graphView.getDataAt(e);
					if (node) {
						if (node._displayName === 'button' && node._tag) {
							// this.returnList.push(this.code);
							// this.code = node._tag;
							// this.isFloor = true;
						}
						if (
							node._displayName === 'kt' ||
							node._displayName === 'kt2' ||
							node._displayName === 'kt3' ||
							node._displayName === 'kt4' ||
							node._displayName === 'ktxt2' ||
							node._displayName === 'kz2'
						) {
							this.kind = '10'
							let code = node._tag.split('_')[0];
							this.deviceCode = code;
							$('#menu').show();
							let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
							$('#menu').css({
								top: scrollTop + e.clientY + 'px',
								left: e.clientX + 'px'
							});
						} else if (node._displayName === '立式水泵') {
							// this.kind = '20'
							// let code = node._tag.split('_')[0];
							// this.deviceCode = code;
							// $('#menu').show();
							// let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
							// $('#menu').css({
							// 	top: scrollTop + e.clientY + 'px',
							// 	left: e.clientX + 'px'
							// });
						}
					} else {
						$('#menu').hide();
					}
				});

				addEvent(this.graphView.getView(), 'touchstart', e => {
					let node = this.graphView.getDataAt(e);
					clearTimeout(timeOutEvent);
					timeOutEvent = 0;
					timeOutEvent = setTimeout(() => {
						if (node) {
							if (node._displayName === 'button' && node._tag) {
								// this.returnList.push(this.code);
								// this.code = node._tag;
								// this.isFloor = true;
							}
							if (
								node._displayName === 'kt' ||
								node._displayName === 'kt2' ||
								node._displayName === 'kt3' ||
								node._displayName === 'kt4' ||
								node._displayName === 'ktxt2' ||
								node._displayName === 'kz2'
							) {
								this.kind = '10'
								let code = node._tag.split('_')[0];
								this.deviceCode = code;
								$('#menu').show();
								let scrollTop = document.documentElement.scrollTop || document.body
									.scrollTop;
								$('#menu').css({
									top: scrollTop + e.changedTouches[0].clientY + 'px',
									left: e.changedTouches[0].clientX + 'px'
								});
							} else if (node._displayName === '立式水泵') {
								// this.kind = '20'
								// let code = node._tag.split('_')[0];
								// this.deviceCode = code;
								// $('#menu').show();
								// let scrollTop = document.documentElement.scrollTop || document.body
								// 	.scrollTop;
								// $('#menu').css({
								// 	top: scrollTop + e.changedTouches[0].clientY + 'px',
								// 	left: e.changedTouches[0].clientX + 'px'
								// });
							}
						} else {
							$('#menu').hide();
						}
					}, 500);
				})

				addEvent(this.graphView.getView(), 'touchend', e => {
					let node = this.graphView.getDataAt(e);
					clearTimeout(timeOutEvent)
					if (timeOutEvent != 0) {
						//click事件
						if (!node) {
							// console.log('隐藏')
							$('#menu').hide();
						}
					}
				});

				//  addEvent(this.graphView.getView(), 'touchmove', e => {
				//    clearTimeout(timeOutEvent);//清除定时器
				//    timeOutEvent = 0;
				// $('#menu').hide();
				//  });
			},
			visibilityChange() {
				if (typeof document.hidden !== 'undefined') {
					// Opera 12.10 and Firefox 18 and later support
					this.hidden = 'hidden';
					this.visibilityChange = 'visibilitychange';
				} else if (typeof document.msHidden !== 'undefined') {
					this.hidden = 'msHidden';
					this.visibilityChange = 'msvisibilitychange';
				} else if (typeof document.webkitHidden !== 'undefined') {
					this.hidden = 'webkitHidden';
					this.visibilityChange = 'webkitvisibilitychange';
				}
				// 如果页面是隐藏状态，则清除定时器
				// 如果页面是展示状态，则重新调用定时器
				addEvent(document, this.visibilityChange, this.handlerVisibilityChange);
			},
			handlerVisibilityChange() {
				if (document[this.hidden]) {
					clearInterval(this.interval);
					this.intervalClear();
				} else {
					if (this.isFloor) {
						this.floorInit();
						// 间隔60s更新一次数据，将所有的定时器存放在数组中
						this.interval = setInterval(this.floorInit, 60000);
					} else {
						this.systemInit();
						// 间隔60s更新一次数据，将所有的定时器存放在数组中
						this.interval = setInterval(this.systemInit, 60000);
					}
				}
			},
			intervalClear() {
				if (this.intervalList.length !== 0) {
					for (let item of this.intervalList) {
						clearInterval(item);
					}
					this.intervalList = [];
				}
			},
			changeDialogVisible(b) {
				this.dialogVisible = b;
			}
		},
	};
</script>

<style lang="scss">
	#buildingRightTop {
		height: 8.1rem;
		width: 16.225rem;

		.el-input--suffix .el-input__inner {
			background-color: #FFF;
			color: #606266;
			border: 1px solid #DCDFE6;
		}

		.typeButton {
			width: 1.1rem;
			height: 0.4rem;
			background: linear-gradient(#063564, #045197);
			border: 1px solid #2CDFE8;
			transform: skewX(-20deg);
			font-size: 0.18rem;
			text-align: center;
			font-weight: bold;
			line-height: 0.4rem;
			color: #fff;
			cursor: pointer;

			p {
				transform: skewX(20deg);
			}
		}

		.primary {
			width: 1.1rem;
			height: 0.4rem;
			background: linear-gradient(#063564, #045197);
			border: 1px solid #2CDFE8;
			transform: skewX(-20deg);
			font-size: 0.18rem;
			text-align: center;
			font-weight: bold;
			line-height: 0.4rem;
			color: #fff;
			opacity: 0.7;
			cursor: pointer;

			p {
				transform: skewX(20deg);
			}
		}
		
		.sebutton{
			background-color: #045197;
		}

		.no-full {
			// width: calc(100%);
			// height: 100vh;
			// min-height: 6.8rem;
		}

		.full {
			// position: fixed;
			// top: 0;
			// left: 0;
			// width: 1920px;
			// height: 1080px;
			// z-index: 9999;
		}

		.plan-wrap {
			width: 16rem;
			min-height: 7.45rem;
			margin: 0 auto;
			background-color: rgba(14, 50, 89, 0.6);
			// opacity: 0.5;
			
			position: relative;
			
			.plan_box{
				height: 90%;
				// opacity: 1;
				
				.fullBtn {
					position: absolute;
					top: 0.5rem;
					right: 0.5rem;
					color: #18FEFE;
					font-size: 0.3125rem;
					cursor: pointer;
				}
				
				.plan {
					width: 100%;
					height: 100%;
					min-height: 6.8rem;
					position: relative;
				
					.ht_box {
						width: 100%;
						height: 100%;
						position: absolute;
					}
				}
			}
		}

		.list {
			height: 0.4rem;

			ul {
				height: 0.4rem;
				
				.system{
					width: 2rem;
				}

				li {
					width: 0.82rem;
					height: 0.4rem;
					margin-left: 0.1rem;
					font-size: 0.15rem;
					padding: 0 0.1rem;
					border: 1px solid lightgray;
					text-align: center;
					line-height: 0.4rem;
					color: lightgray;
					border-radius: 2px;
					overflow: hidden;
					cursor: pointer;
					opacity: 0.7;
				}
			}
		}

		#menu {
			width: 140px;
			border: 1px solid #ddd;
			background: #fff;
			user-select: none;
			z-index: 999;
			display: none;
			position: fixed;
		}

		#menu ul li {
			line-height: 32px;
			text-align: center;
			color: #666;
			cursor: pointer;
		}

		#menu ul li:hover {
			background: #efefef;
		}

		.el-dialog__headerbtn {
			top: 10px;

			.el-dialog__close {
				color: #fff;
			}
		}

		.el-dialog__body {
			// height: 60vh;
			overflow-y: auto;
		}
	}
</style>
